import { render, staticRenderFns } from "./DatasetTableData.vue?vue&type=template&id=6be10883&scoped=true"
import script from "./DatasetTableData.vue?vue&type=script&lang=js"
export * from "./DatasetTableData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be10883",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6be10883')) {
      api.createRecord('6be10883', component.options)
    } else {
      api.reload('6be10883', component.options)
    }
    module.hot.accept("./DatasetTableData.vue?vue&type=template&id=6be10883&scoped=true", function () {
      api.rerender('6be10883', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/common/DatasetTableData.vue"
export default component.exports